module.exports = __webpack_public_path__ + "media/images/icons/ic-play-41d959ee022fdc013b51463d0bca688d.svg";